export enum LoanDetailAction {
  DESIST = 'DESIST',
  REFUND = 'REFUND',
  CANCEL = 'CANCEL',
  CANCEL_TEST = 'CANCEL_TEST',
  FORMALIZE_APPLICATION = 'FORMALIZE_APPLICATION',
  MARK_LOAN_AS_PAID = 'MARK_LOAN_AS_PAID',
  ADD_PARTICIPANT_TO_LOAN = 'ADD_PARTICIPANT_TO_LOAN',
  REMOVE_PARTICIPANT_FROM_LOAN = 'REMOVE_PARTICIPANT_FROM_LOAN',
  UPDATE_LOAN_APPLICATION_IN_LENDER = 'UPDATE_LOAN_APPLICATION_IN_LENDER',
  CHANGE_LOAN_CONDITIONS = 'CHANGE_LOAN_CONDITIONS',
  OPT_OUT_NOTIFICATIONS = 'OPT_OUT_NOTIFICATIONS',
}
